import {CssBaseline, GlobalStyles} from "@mui/material";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import liftPortalTheme from "./themes/liftPortalTheme";
import Login from "./views/login/Login";
import MfaForm from "./views/mfa/MfaForm";
import SsoEnforced from "./views/login/SsoEnforced";
import LoginForm from "./views/login/LoginForm";
import SignUp from "./views/login/SignUp";
import ForgotPassword from "./views/login/ForgotPassword";
import ResetPassword from "./views/login/ResetPassword";
import ErrorHandler from "./views/login/ErrorHandler";

const theme = createTheme(liftPortalTheme);

const router = createBrowserRouter([
    {
        path: "/",
        element: <Navigate to={"/login"}/>
    },
    {
        path: "/login",
        element: <Login/>,
        children: [
            {index: true, element: <LoginForm/>},
            {path: "/login/sso-enforced", element: <SsoEnforced/>}
        ]
    },
    {
        path: "/mfa",
        element: <MfaForm/>
    },
    {
        path: "/signup/:id",
        element: <SignUp/>
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword/>
    },
    {
        path: "/reset-password/:id",
        element: <ResetPassword/>
    },
    {
        path: "*",
        element: <ErrorHandler/>
    }
]);

function App() {
    window.pendo.initialize({
        visitor: {
            id: ""
        }
    });
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles styles={{ul: {margin: 0, padding: 0, listStyle: 'none'}}}/>
            <CssBaseline/>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <RouterProvider router={router}/>
        </ThemeProvider>
    );
}

export default App;
